import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';


export const invoiceSystemV2Purchase = (params) => {
    params.agentType='MANAGE';
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/purchase?` + params,
        method: 'GET',
    })
}

export const invoiceSystemV2PurchaseOut = (ids) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/purchase/out/${ids}`,
        method: 'PUT'
    })
}
export const invoiceSystemV2PurchaseDownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/purchase/downloadExcel?` + params,
        method: 'GET',
    })
}

export const stockRemovalReturn = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/purchase/dissident/${id}?` + params,
        method: 'GET'
    })
}

export const invoiceSystemV2PurchaseReturned = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/purchase/returned/${id}?` + params,
        method: 'PUT'
    })
}

export const findStockRemovalDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/purchase/detail/${id}`,
        method: 'GET',
    })
}
export const invoiceSystemV2PurchaseDetail = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/purchase/${id}`,
        method: 'GET',
    })
}

export const invoiceSystemV2PurchaseDetail1 = (id) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/delivery-order/detail/${id}`,
        method: 'GET',
    })
}













// export const downloadPDF = (id) => {
//     return request({
//         url: `${baseUrl}/joins-invoice-system/v1/purchase/exportPurchaseDetail/${id}`,
//         method: 'GET',
//     })
// }
export const downloadPDF = (id) => {
    let url = `${baseUrl}` + `/joins-invoice-system/v1/purchase/exportPdfPurchaseDetail/${id}`
    window.open(url);
}